import { z } from 'zod';
import { objectIdSchema } from '../../validation';

export const timelineTargetTypeSchema = z.enum(['order', 'invoice', 'etc']);
export type TimelineTargetType = z.infer<typeof timelineTargetTypeSchema>;

export const timelineTargetSchema = z.object({
  /** _id is used to identify relations such as an id for:
   * - Order
   * - Customer
   * - Invoice
   * - etc.
   *
   * By using the primaryId, you can find all actions & events.
   */
  _id: objectIdSchema,
  /** this will mainly be used for db collection names */
  type: timelineTargetTypeSchema,
});
export type TimelineTarget = z.infer<typeof timelineTargetSchema>;
